import { combineReducers } from 'redux';

import {
    SEND_INVITATIONS_REQUEST,
    SEND_INVITATIONS_SUCCESS,
    SEND_INVITATIONS_FAILURE,
    SEND_INVITATION_REMINDS_REQUEST,
    SEND_INVITATION_REMINDS_SUCCESS,
    SEND_INVITATION_REMINDS_FAILURE,
    SEND_PURCHASE_REMINDS_REQUEST,
    SEND_PURCHASE_REMINDS_SUCCESS,
    SEND_PURCHASE_REMINDS_FAILURE
} from './constants';

const sendingInvitations = (state = false, action) => {
    switch (action.type) {
        case SEND_INVITATIONS_REQUEST:
            return true;
        case SEND_INVITATIONS_SUCCESS:
        case SEND_INVITATIONS_FAILURE:
            return false;
        default:
            return state;
    }
};

const sendingInvitationsSucceeded = (state = false, action) => {
    switch (action.type) {
        case SEND_INVITATIONS_SUCCESS:
            return true;
        case SEND_INVITATIONS_REQUEST:
        case SEND_INVITATIONS_FAILURE:
            return false;
        default:
            return state;
    }
};

const sendingInvitationsFailed = (state = '', action) => {
    switch (action.type) {
        case SEND_INVITATIONS_FAILURE:
            return action.response.message;
        case SEND_INVITATIONS_REQUEST:
        case SEND_INVITATIONS_SUCCESS:
            return false;
        default:
            return state;
    }
};

const sendingInvitationReminds = (state = false, action) => {
    switch (action.type) {
        case SEND_INVITATION_REMINDS_REQUEST:
            return true;
        case SEND_INVITATION_REMINDS_SUCCESS:
        case SEND_INVITATION_REMINDS_FAILURE:
            return false;
        default:
            return state;
    }
};

const sendingInvitationRemindsSucceeded = (state = false, action) => {
    switch (action.type) {
        case SEND_INVITATION_REMINDS_SUCCESS:
            return true;
        case SEND_INVITATION_REMINDS_REQUEST:
        case SEND_INVITATION_REMINDS_FAILURE:
            return false;
        default:
            return state;
    }
};

const sendingInvitationRemindsFailed = (state = '', action) => {
    switch (action.type) {
        case SEND_INVITATION_REMINDS_FAILURE:
            return action.response.message;
        case SEND_INVITATION_REMINDS_REQUEST:
        case SEND_INVITATION_REMINDS_SUCCESS:
            return false;
        default:
            return state;
    }
};

const sendingPurchaseReminds = (state = false, action) => {
    switch (action.type) {
        case SEND_PURCHASE_REMINDS_REQUEST:
            return true;
        case SEND_PURCHASE_REMINDS_SUCCESS:
        case SEND_PURCHASE_REMINDS_FAILURE:
            return false;
        default:
            return state;
    }
};

const sendingPurchaseRemindsSucceeded = (state = false, action) => {
    switch (action.type) {
        case SEND_PURCHASE_REMINDS_SUCCESS:
            return true;
        case SEND_PURCHASE_REMINDS_REQUEST:
        case SEND_PURCHASE_REMINDS_FAILURE:
            return false;
        default:
            return state;
    }
};

const sendingPurchaseRemindsFailed = (state = '', action) => {
    switch (action.type) {
        case SEND_PURCHASE_REMINDS_FAILURE:
            return action.response.message;
        case SEND_PURCHASE_REMINDS_REQUEST:
        case SEND_PURCHASE_REMINDS_SUCCESS:
            return false;
        default:
            return state;
    }
};

const reducer = combineReducers({
    sendingInvitations,
    sendingInvitationsSucceeded,
    sendingInvitationsFailed,
    sendingInvitationReminds,
    sendingInvitationRemindsSucceeded,
    sendingInvitationRemindsFailed,
    sendingPurchaseReminds,
    sendingPurchaseRemindsSucceeded,
    sendingPurchaseRemindsFailed
});

export default reducer;



// WEBPACK FOOTER //
// ./src/services/sponsorship/reducer.js